import nestedComponentForm from 'formiojs/components/_classes/nested/NestedComponent.form';
import { BaseEdit } from '../../configuration-components/base-widget-configuration';
import { CustomComponentType } from '../../../enums/custom-component-type';

export default function(...extend: any) {
	return nestedComponentForm(BaseEdit.getInfoWidgetTabs(CustomComponentType.personalInfo), ...extend);
}
